import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const mediaUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

/**
 * Turn a FastAPI/Pydantic error payload into a plain string safe for `toast.error`.
 * Pydantic 422 responses put an array of `{type, loc, msg, input, ctx}` objects into
 * `err.response.data.detail`, which crashes React if rendered directly.
 */
export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === "string") return d;
        const field = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : "";
        return field ? `${field}: ${d?.msg || "invalid"}` : (d?.msg || "invalid");
      })
      .join(" · ");
  }
  if (typeof detail === "object" && detail && typeof detail.message === "string") return detail.message;
  return fallback;
}
